__turbopack_context__.v({
  "className": "QnPKCq_className",
  "variable": "QnPKCq_variable",
});
